import Model, { attr } from '@ember-data/model';

export default class StatisticModel extends Model {
	@attr('number') time;
	@attr('number') chip;
	@attr('number') decodeCount;
	@attr('number') batteryVolts;
	@attr('number') uptimeHours;
	@attr('number') ageHours;
	@attr('number') inMotionSeconds;
	@attr('number') loopDecodingSeconds;
	@attr('number') decodedLoopPackets;
	@attr('number') gX;
	@attr('number') gY;
	@attr('number') gZ;
	@attr('number') lastLoopId;
	@attr('number') aX;
	@attr('number') aY;
	@attr('number') stat16;
	@attr('boolean') stat17;
	@attr('number') stat18;
	@attr('number') stat19;
	@attr('number') stat20;
	@attr('boolean') reSent;
}
